/**
 * Get the shared mail parameters from the URL
 */
const getSharedMailParamsFromUrl = () => {
  const pathname = window.location.pathname;

  const paramList = _parseKeyValuePairs(pathname);

  return {
    key: paramList?.j || "",
    collectionId: paramList?.c || "",
    userId: paramList?.u || "",
    encryptedRequestUserEmail: paramList?.r || "",
    encryptedRequestSenderEmail: paramList?.sm || "",
    encryptedDeletedLinkRequest: paramList?.delete || "",
    encryptedContributorEmail: paramList?.con || "",
  };
};

const _parseKeyValuePairs = (input: string): Record<string, string> => {
  const result: Record<string, string> = {};

  // Split the input string into segments by "/"
  const segments = input.split("/").filter((segment) => !!segment);

  // Ensure segments come in pairs of key and value
  for (let i = 0; i < segments.length - 1; i += 2) {
    const key = segments[i];
    const value = segments[i + 1];

    // Only add valid pairs
    if (key && value) {
      result[key] = value;
    }
  }

  return result;
};

export default getSharedMailParamsFromUrl;
